import { checkOnboarding } from '#core/services/OnboardingChecker';
import { defineStore } from 'pinia';
import type { User } from '../types';

export const useAuthStore = defineStore('auth', () => {
  const { data } = useAuth();
  const user = ref<User>(data.value?.data || null);
  const getUser = computed(() => user.value || ({} as User));
  const hasLoggedInUser = computed(() => Boolean(user.value));
  const hasCompletedOnboarding = computed(() => user.value?.first_name && user.value?.last_name);
  const isVerified = computed(() => user.value?.email_verified);
  const onboardingCompleted = computed(() => checkOnboarding(getUser.value));

  const role = computed(() => data.value?.data?.role ?? null);

  const isManager = computed(() => role.value === 'MANAGER');
  const isTradie = computed(() => role.value === 'EMPLOYEE');

  watch(
    () => data.value,
    (newData) => {
      user.value = newData?.data ?? null;
    },
    { immediate: true }
  );

  return {
    user,
    getUser,
    hasLoggedInUser,
    hasCompletedOnboarding,
    isVerified,
    onboardingCompleted,
    isManager,
    isTradie,
    role,
  };
});
